// 是否发起资金划扣
export const WITHHOLD_TYPE_MAP = {
  YES: 1,
  NO: 0,
}

export const withholdTypeList = {
  [WITHHOLD_TYPE_MAP.YES]: '是',
  [WITHHOLD_TYPE_MAP.NO]: '否',
}

// 签署方式
export const SIGN_CHANNEL_MAP = {
  ONLINE: 2,
  OFFLINE: 1,
}
export const signChannelList = {
  [SIGN_CHANNEL_MAP.ONLINE]: '线上签署',
  [SIGN_CHANNEL_MAP.OFFLINE]: '线下签署',
}

export const FIXED_MAP = {
  LOCK: 1,
  UNLOCK: 0,
}

// 合同签署状态
export const CONTRACT_STATE_MAP = {
  TO_SIGN: 0, // 待发起
  SIGNING: 1, // 签署中
  COMPLETE: 2, // 已签约
  REVERT: 3, // 已撤回
  OUT_DATE: 5, // 已过期
  REJECT: 7, // 已驳回
  FAIL: 8, // 签约失败
}

export const contractStateList = {
  [CONTRACT_STATE_MAP.TO_SIGN]: '待发起',
  [CONTRACT_STATE_MAP.SIGNING]: '签署中',
  [CONTRACT_STATE_MAP.COMPLETE]: '已签约',
  [CONTRACT_STATE_MAP.REVERT]: '已撤回',
  [CONTRACT_STATE_MAP.OUT_DATE]: '已过期',
  [CONTRACT_STATE_MAP.REJECT]: '已驳回',
  [CONTRACT_STATE_MAP.FAIL]: '签约失败',
}

// 签署审批状态
export const SIGN_APPROVAL_STATE_MAP = {
  PENDING_APPROVAL: 10, // 待审批
  ALREADY_WITHDRAWN: 20, // 已撤回
  ALREADY_REJECTED: 30, // 已驳回
  ALREADY_PASSED: 40, // 已通过
}

export const ORDER_SOURCE_MAP = {
  VEHICLE_AFFAIRS: 1,
  RENTAL_MALL: 2,
}

export const WITH_HOLD_ENABLE_MAP = {
  ENABLE: 1,
  DISABLE: 0,
}

export const signBtnText = {
  [CONTRACT_STATE_MAP.TO_SIGN]: '发起签署',
  [CONTRACT_STATE_MAP.SIGNING]: '撤回签署',
  [CONTRACT_STATE_MAP.COMPLETE]: '查看详情',
  [CONTRACT_STATE_MAP.REVERT]: '重新发起签署',
  [CONTRACT_STATE_MAP.OUT_DATE]: '重新发起签署',
  [CONTRACT_STATE_MAP.REJECT]: '重新发起签署',
  [CONTRACT_STATE_MAP.FAIL]: '重新发起签署',
}

/**
 * 支付方式
 * 网约钱包：driverIncome
 * 支付宝：alipay
 */
export const PAYMENT_METHOD = {
  DRIVER_INCOME: 'driverIncome',
  ALIPAY: 'alipay',
}

export const PAYMENT_METHOD_TEXT = {
  [PAYMENT_METHOD.DRIVER_INCOME]: '网约钱包支付',
  [PAYMENT_METHOD.ALIPAY]: '支付宝支付',
}

/**
 * 租赁类型
 * 租赁：1
 * 以租代购：2
 * 车主合伙人模式：4
 */
export const RENT_CATEGORY = {
  LEASE: 1, // 租赁
  LEASE_PURCHASE: 2, // 以租代购
  OWNER_OPERATOR_MODEL: 4, // 车主合伙人模式
}
